import SafeAreaContainer from "../components/safe-area-container";
import Paragraph from "../components/paragraph";
import { Button, List } from "@mantine/core";
import { ExternalLink } from "tabler-icons-react";
import { useTranslation } from "react-i18next";

import {useStyles} from "../styles"

export default function WLANPage() {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <div>
        <SafeAreaContainer>
            <div className={classes.container}>

                <h1 className={classes.title}>{t("OnboardPage.title")}</h1>

                <div className={classes.content}>
                    <Paragraph>
                    {t("OnboardPage.para1")}
                    </Paragraph>
                </div>

                <div className={classes.content}>
                    <Paragraph>
                    {t("OnboardPage.para4")}
                    </Paragraph>
                </div>

                <Button className={classes.headerbutton} component="a" href={t("OnboardPage.link4")} target="_blank" leftIcon={<ExternalLink size={14} />}>
                {t("OnboardPage.button4")}
                </Button>

                <div className={classes.content}>
                    <h2>
                        {t("OnboardPage.para2")}
                    </h2>
                </div>

                <div className={classes.content}>
                    <h2>
                        {t("OnboardPage.step3")}
                    </h2>
                </div>

                <div className={classes.content}>
                    <Paragraph>
                    {t("OnboardPage.para3")}
                    </Paragraph>
                </div>

                <Button className={classes.headerbutton} component="a" href={t("OnboardPage.link3")} target="_blank" leftIcon={<ExternalLink size={14} />}>
                {t("OnboardPage.button3")}
                </Button>

                <div className={classes.content}>
                    <h2>
                        {t("OnboardPage.step6")}
                    </h2>
                </div>

                <div className={classes.content}>
                    <Paragraph>
                    {t("OnboardPage.para6")}
                    </Paragraph>
                </div>

                <div style={{ display: "flex", gap: "16px" }}>
                    <Button className={classes.headerbutton} component="a" href={t("OnboardPage.link6")} target="_blank" leftIcon={<ExternalLink size={14} />}>
                        {t("OnboardPage.button6")}
                    </Button>

                    <Button className={classes.headerbutton} component="a" href={t("OnboardPage.link6_1")} target="_blank" leftIcon={<ExternalLink size={14} />}>
                        {t("OnboardPage.button6_1")}
                    </Button>
                    </div>

                <div className={classes.content}>
                    <h2>
                        {t("OnboardPage.step7")}
                    </h2>
                </div>

                <div className={classes.content}>
                    <Paragraph>
                    {t("OnboardPage.para7")}
                    </Paragraph>
                </div>

                <Button className={classes.headerbutton} component="a" href={t("OnboardPage.link7")} target="_blank" leftIcon={<ExternalLink size={14} />}>
                {t("OnboardPage.button7")}
                </Button>

                <div className={classes.content}>
                    <h2>
                        {t("OnboardPage.step8")}
                    </h2>
                </div>

                <div className={classes.content}>
                    <Paragraph>
                    {t("OnboardPage.para8")}
                    </Paragraph>
                </div>

                <Button className={classes.headerbutton} component="a" href={t("OnboardPage.link8")} target="_blank" leftIcon={<ExternalLink size={14} />}>
                {t("OnboardPage.button8")}
                </Button>

            </div>
        </SafeAreaContainer>
    </div>
  );
}
                    